export default {
  props: ['value', 'size'],

  methods: {
    triggerChange(changedValue) {
      this.$emit('change', changedValue);
    }
  }
}